import { useToast } from "@repo/ui";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";
import type { LinkStatusActionRequest } from "~/types/api";

export type Props = {
  linkStatus: (
    workflowId: number,
    actionId: number,
    statusCode: LinkStatusActionRequest["statusCode"],
    sortOrder: LinkStatusActionRequest["sortOrder"]
  ) => Promise<unknown>;
  isLinking: boolean;
  isSuccess: boolean;
  isError: boolean;
};

export const useLinkActionStatus = (): Props => {
  const { showToast } = useToast();

  const linkStatusesMutation = configurationApi.useMutation(
    "post",
    "/api/workflow/{workflowId}/Procedure/{procedureId}/status",
    {
      onError: (error) => {
        showToast("error", getErrorMessage(error, "Failed to link action status"), "Error");
      },
    }
  );

  const linkStatuses = async (
    workflowId: number,
    actionId: number,
    statusCode: LinkStatusActionRequest["statusCode"],
    sortOrder: LinkStatusActionRequest["sortOrder"]
  ) => {
    return linkStatusesMutation.mutateAsync({
      params: { path: { workflowId, procedureId: actionId } },
      body: { statusCode, sortOrder },
    });
  };

  return {
    linkStatus: linkStatuses,
    isLinking: linkStatusesMutation.isPending,
    isSuccess: linkStatusesMutation.isSuccess,
    isError: linkStatusesMutation.isError,
  };
};
